import { render, staticRenderFns } from "./AffiliateCompaniesTable.vue?vue&type=template&id=268f302c&"
import script from "./AffiliateCompaniesTable.vue?vue&type=script&lang=js&"
export * from "./AffiliateCompaniesTable.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateCompaniesTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports